import { useMutation } from '@tanstack/react-query'

import { useAuth, useTRPC } from '@langmail/shared-ui'

import { useToast } from '@/hooks/ui/use-toast'

export const useDeleteAccount = () => {
  const { toast } = useToast()
  const { signOut } = useAuth()
  const trpc = useTRPC()

  const mutation = useMutation({
    ...trpc.user.deleteAccount.mutationOptions(),
    onSuccess: async (result) => {
      if (result.success) {
        toast({
          title: 'Account deleted',
          description: 'Your account has been permanently deleted.',
        })

        await signOut()

        window.location.assign('/login')
      } else {
        toast({
          title: 'Error',
          description: result.message || 'Failed to delete account',
          variant: 'destructive',
        })
      }
    },
    onError: (error) => {
      toast({
        title: 'Error',
        description: error instanceof Error ? error.message : 'Failed to delete account',
        variant: 'destructive',
      })
    },
  })

  return mutation
}
